import { render } from "./InputMask.vue?vue&type=template&id=2cb99203&ts=true"
import script from "./InputMask.vue?vue&type=script&lang=ts"
export * from "./InputMask.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__